export const getUserSelector = (state) => state.authReducer.user;
export const getStepSelector = (state) => state.authReducer.step;